import { PromoShowPurchaseSource } from '@/helpers/gtm-triggers/gtm-triggers';

export function isPopoverModalSource(source: PromoShowPurchaseSource): boolean {
  return ['chat-send-message', 'search-insufficient-likes', 'profile-insufficient-likes'].includes(
    source,
  );
}
